<template>
	<div>
        <b-modal id="payment-request" title="Ödeme Bağlantısı Oluştur" no-close-on-esc no-close-on-backdrop>
            <payment-request v-model="paymentRequest"></payment-request>
            <template #modal-footer><v-executer :loading="loading" text="Oluştur" :action="createPaymentRequest"></v-executer></template>
        </b-modal>
       <b-overlay :show="psLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <h2 class="p-25 font-weight-bolder">Ödeme Hareketleri</h2>
                <div class="row mb-1">
                    <div class="col-md-3">
                        <v-date-picker range v-model="date"></v-date-picker>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" v-on:click="paymentRequestList">Sorgula</button>
                    </div>
                    <div v-if="paymentRequestButtonControl()" class="col-md-3">
                        <button class="btn btn-primary" v-on:click="openPaymentRequestModal" >Ödeme Bağlantısı Oluştur</button>
                    </div>
                </div>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1 ">
                        <thead>
                            <tr>
                                <th class="text-nowrap w-10">Ödeme Kodu</th>
                                <th class="text-nowrap w-10">E-Posta</th>
                                <th class="text-nowrap w-20">Açıklama</th>
                                <th class="text-nowrap w-7">Gönderilme Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(ps,i) in paymentRequests" >
                                <tr :key="i">
                                    <td class="text-nowrap">
                                        <a :href="'/Payment/'+ps.PaymentCode" target="_blank">{{$safe(ps,'PaymentCode') || '-'}}</a>
                                    </td>
                                    <td class="text-nowrap">{{$safe(ps,'Email') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'Description') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'CreateTime') || '-'}}</td>
                                </tr>
                                <tr  :key="i + '-dl'" v-if="ps.PaymentActions">
                                    <td colspan="20">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                             
                                                    <th class="text-nowrap w-15">Toplam Ödenecek Tutar</th>
                                                    <th class="text-nowrap w-15">Ödenen Tutar</th>
                                                    <th class="text-nowrap w-15">Kalan Tutar</th>
                                                    <th class="text-nowrap w-30">Durum</th>
                                                    <th class="text-nowrap w-25">Ödeme Zamanı</th>

                                                </thead>
                                                <tbody>
                                                    <tr :class="setPaymentStatusColor(dl.Status)" v-for="(dl,index) in ps.PaymentActions" :key="index">
                                                        
                                                        <td>{{$safe(dl,'TotalAmount') || '-'}}</td>
                                                        <td>{{$safe(dl,'PaidAmount') || '-'}}</td>
                                                        <td>{{$safe(dl,'RemainingAmount') || '-'}}</td>
                                                        <td>{{$safe(dl,'StatusStr') || '-'}}</td>
                                                        <td>{{$safe(dl,'PaidTime') || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="paymentRequests.length == 0">
                                <td colspan="20" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

	</div>
</template>

<script>
import { BCard, BCardText, BLink,BImg,BOverlay,BSpinner } from 'bootstrap-vue'
//import Notifications from '@/utilities/notifications'
import {PaymentApi} from '@/api/payment'
import VStatsBox from '@/components/VStatsBox.vue'
import PaymentRequest from './components/PaymentRequest.vue'
import Auth from '@/utilities/auth'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BImg,
        VStatsBox,
        VuePerfectScrollbar,
        PaymentRequest,
        BOverlay,
        BSpinner
    },
    data() {
        return {
            date:null,
            month:null,
            paymentRequests:[],
            responsibleUserPaymentStatuses:[],
            psLoading:false,
            rupsLoading:false,
            approving:false,
            cid:null,
            pending:false,
            loading:false,
            paymentRequest:{
                TotalAmount:null,
                CanInstallment:null,
                Description:null,
                CustomerUserId:null
            }
        }
    },
    mounted(){
        this.date = [
            moment().subtract(1,'week').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD'),
        ]
        this.paymentRequestList()
    },
    methods:{
        clearPaymentRequestForm(){
            this.paymentRequest.TotalAmount=null
            this.paymentRequest.CanInstallment=false
            this.paymentRequest.Description=null
            this.paymentRequest.CustomerUserId=null
        },
        paymentRequestButtonControl(){
            let check = Auth.hasRole(['payment.request.send'])
            return check
        },
        openPaymentRequestModal(){
            this.clearPaymentRequestForm()
            this.$showModal('payment-request')
        },
        createPaymentRequest(){
            this.loading = true
            PaymentApi.CreatePaymentRequest(this.paymentRequest).then(res => {
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.paymentRequestList()
                    this.$hideModal('payment-request')
                }
            }).catch(err=>{
                this.loading = false
                console.log(err)
            })
        },
        setPaymentStatusColor(paymentStatus){
            if(paymentStatus == 6 || paymentStatus == 7)
                return 'bg-light-success'
            if(paymentStatus == 5)
                return 'bg-light-primary'
            if(paymentStatus == 4 || paymentStatus == 2)
                return 'bg-light-danger'
            if(paymentStatus == 0)
                return 'bg-light-info'
                if(paymentStatus == 3)
                return 'bg-light-warning'
            return ''
        },
        paymentRequestList(){
            this.psLoading = true
            if(this.date[0] && this.date[1]){
                PaymentApi.PaymentRequestList(this.date[0],this.date[1]).then(res=>{
                    this.psLoading = false
                    this.paymentRequests = res.data.Data
                }).catch(()=>this.psLoading = false)
            }
        },
        
    }
}
</script>

<style>
.card-wrapper{
    max-height:calc(100vh - 22rem);
}

@media screen and (max-width:767px) {
    .card-wrapper{
        max-height:calc(100vh - 30rem);
    }
}
</style>
